import { BrowserRouter, Routes, Route } from "react-router-dom";

// ====================
// WEBSITE
// ====================
import Navbar from "./components/Navbar";

import Home from "./pages/Home";
import About from "./pages/About";
import Courses from "./pages/Courses";
import Services from "./pages/Services";
import Trainers from "./pages/Trainers";
import Achievements from "./pages/Achievements";
import Contact from "./pages/Contact";
import Registration from "./pages/Registration";
import Footer from "./components/Footer";
import WhatsAppButton from "./components/WhatsAppButton";
import ScrollToTop from "./ScrollToTop";
// ====================
// ADMIN
// ====================
import AdminLogin from "./admin/AdminLogin";
import AdminDashboard from "./admin/AdminDashboard";
import AdminTrainers from "./admin/AdminTrainers";
import AdminAchievements from "./admin/AdminAchievements";
import AdminCourses from "./admin/AdminCourses";

function App() {
  return (
    <BrowserRouter>
    <ScrollToTop />
      {/* ====================
          WEBSITE NAVBAR
      ==================== */}
      <Navbar />

      <Routes>

        {/* ====================
            WEBSITE
        ==================== */}

        {/* Home */}
        <Route
          path="/"
          element={<Home />}
        />

        {/* About */}
        <Route
          path="/about"
          element={<About />}
        />

        {/* Courses */}
        <Route
          path="/courses"
          element={<Courses />}
        />

        {/* Services */}
        <Route
          path="/services"
          element={<Services />}
        />

        {/* Trainers */}
        <Route
          path="/trainers"
          element={<Trainers />}
        />

        {/* Achievements */}
        <Route
          path="/achievements"
          element={<Achievements />}
        />

        {/* Registration */}
        <Route
          path="/registration"
          element={<Registration />}
        />

        {/* Contact */}
        <Route
          path="/contact"
          element={<Contact />}
        />

        {/* ====================
            ADMIN
        ==================== */}

        {/* Admin Login */}
        <Route
          path="/admin/login"
          element={<AdminLogin />}
        />

        {/* Admin Dashboard */}
        <Route
          path="/admin"
          element={<AdminDashboard />}
        />

        {/* Admin Trainers */}
        <Route
          path="/admin/trainers"
          element={<AdminTrainers />}
        />

        {/* Admin Achievements */}
        <Route
          path="/admin/achievements"
          element={<AdminAchievements />}
        />

        {/* Admin Courses */}
        <Route
          path="/admin/courses"
          element={<AdminCourses />}
        />

      </Routes>
      <Footer/>
   <WhatsAppButton/>
    </BrowserRouter>
  );
}

export default App;